"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameMode = void 0;
const CTGCard_1 = require("../Logic/CTGCard");
const CTGIntroAnimations_1 = require("../Display/CTGIntroAnimations");
const KHEventHandler_1 = require("../KH/KHEventHandler");
const CTG_1 = require("../CTG");
const standard_animations = [
    new CTGIntroAnimations_1.CTGAnimationFadeInStaggered(),
    new CTGIntroAnimations_1.CTGAnimationFadeIn(),
    new CTGIntroAnimations_1.CTGAnimationFadeInFlip(),
    new CTGIntroAnimations_1.CTGAnimationFadeInFlipStaggered(),
    new CTGIntroAnimations_1.CTGAnimationScaleIn(),
    new CTGIntroAnimations_1.CTGAnimationScaleInStaggered(),
    new CTGIntroAnimations_1.CTGAnimationScaleInFlip(),
    new CTGIntroAnimations_1.CTGAnimationScaleInFlipStaggered(),
    new CTGIntroAnimations_1.CTGAnimationDropIn(),
    new CTGIntroAnimations_1.CTGAnimationDropInStaggered(),
    new CTGIntroAnimations_1.CTGAnimationDropInFlip(),
    new CTGIntroAnimations_1.CTGAnimationDropInFlipStaggered(),
];
let CTGGameMode = /** @class */ (() => {
    class CTGGameMode extends KHEventHandler_1.KHEventHandler {
        constructor(animators) {
            super([
                CTGGameMode.EVENT_CREATE,
                CTGGameMode.EVENT_GAME_STARTED,
                CTGGameMode.EVENT_GAME_ENDED,
                CTGGameMode.EVENT_WON,
                CTGGameMode.EVENT_LOST,
                CTGGameMode.EVENT_SCORE_UPDATE,
                CTGGameMode.EVENT_TIME_UPDATE,
                CTGGameMode.EVENT_INITIAL_CARDS,
                CTGGameMode.EVENT_ADD_CARDS,
                CTGGameMode.EVENT_SHOW_SHIELD,
                CTGGameMode.EVENT_HIDE_SHIELD,
                CTGGameMode.EVENT_CARD_DESTROYED,
            ]);
            this.interact_on_start = true;
            this.show_close = false;
            this.game_over = false;
            this.score = 0;
            this.cards = [];
            this._animators = animators;
        }
        supported_animations() {
            return standard_animations;
        }
        lose(cards_to_highlight = []) {
            if (this.game_over) {
                return;
            }
            this.game_ended();
            this.emitEvent(CTGGameMode.EVENT_LOST, { cards: cards_to_highlight });
            console.log("Lost");
        }
        win() {
            if (this.game_over) {
                return;
            }
            this.game_ended();
            this.emitEvent(CTGGameMode.EVENT_WON);
            console.log("Won");
        }
        on_end() {
            this.cards.forEach(card => {
                card.destroy(true, false);
            });
        }
        game_ended() {
            this.game_over = true;
            this.cards.forEach(card => {
                card.set_can_interact(false);
            });
            this.started = false;
            this.emitEvent(CTGGameMode.EVENT_GAME_ENDED);
            this.scene = null;
        }
        set_score(new_value, percent) {
            percent = Math.min(1, percent);
            this.score = new_value;
            this.emitEvent(CTGGameMode.EVENT_SCORE_UPDATE, { score: new_value, percent: percent });
        }
        set_time(new_value, delta, time_left, percent) {
            this.emitEvent(CTGGameMode.EVENT_TIME_UPDATE, { time: new_value, delta: delta, time_left: time_left, percent: percent });
            if (percent >= 1) {
                if (this.win_on_time_out)
                    this.win();
                else
                    this.lose(this.cards_to_highlight_on_time_out());
            }
        }
        cards_to_highlight_on_time_out() {
            return [];
        }
        reset() {
            this.scene = null;
            this.score = 0;
            this.game_over = false;
            this.difficulty = 0;
            this.cards = [];
        }
        cards_added(cards, can_interact) {
            for (let card of cards) {
                this.cards.push(card);
                card.set_can_interact(can_interact);
                this.emitEvent(CTGGameMode.EVENT_CREATE, { card: card });
                card.registerCallback(CTGCard_1.CTGCard.EVENT_TAPPED, (data) => {
                    this.card_tapped(data.card);
                });
                card.registerCallback(CTGCard_1.CTGCard.EVENT_DESTROY, (data) => {
                    this.cards = this.cards.filter(function (el) { return el != data.card; });
                    this.card_destroyed(data.card);
                    this.emitEvent(CTGGameMode.EVENT_CARD_DESTROYED, { card: card });
                });
            }
            this.cards_generated(cards);
            if (this._animators) {
                for (const animator of this._animators) {
                    animator.on_add_cards(this.rand, this.scene, cards, this.difficulty);
                }
            }
        }
        get_time_limit(difficulty) {
            return CTGGameMode.TIME_LIMIT;
        }
        on_start(scene, rand, difficulty) { }
        start(scene, rand, difficulty) {
            this.reset();
            this.scene = scene;
            this.rand = rand;
            this.difficulty = difficulty;
            this.on_start(scene, rand, difficulty);
            if (this._animators) {
                for (const animator of this._animators) {
                    animator.initial_settings(this.rand, this.scene, this.difficulty);
                }
            }
            let cards = this.generate_initial_cards(rand, difficulty);
            this.cards_added(cards, false);
            this.emitEvent(CTGGameMode.EVENT_INITIAL_CARDS, { cards: cards });
        }
        did_start(scene) {
            this.cards.forEach(card => {
                card.set_can_interact(this.interact_on_start);
            });
            this.start_time = scene.time.now;
            this.started = true;
            this.emitEvent(CTGGameMode.EVENT_GAME_STARTED, {});
            this.set_score(0, 0);
            this.set_time(0, 0, this.get_time_limit(this.difficulty), 0);
        }
        update(scene, now, delta, difficulty, mx, my, mdown) {
            if (this.game_over || !this.started)
                return;
            let new_time = now - this.start_time;
            this.set_time(new_time, delta, this.get_time_limit(this.difficulty) - new_time, new_time / this.get_time_limit(this.difficulty));
            this.update_game(scene, now, delta, difficulty, mx, my, mdown);
            if (this._animators) {
                for (const animator of this._animators) {
                    animator.update_game(this.rand, scene, this.cards, now, delta, difficulty);
                }
            }
        }
        clicked(scene, mx, my) { }
        /**
         * Returns the absolute X position of cards laid out by a normal index.
         * @param x
         */
        fixed_x_position(x) {
            return 2 + x * this.spacing() + 5;
        }
        /**
         * Returns the absolute Y position of cards laid out by a normal index.
         * @param y
         */
        fixed_y_position(y) {
            return 62 - y * this.spacing() - 7;
        }
        spacing() {
            return Math.floor(60 / 4);
        }
        check_for_card_collisions(card, others, dont_overlap_allowance = 2) {
            if (card == null)
                return [];
            return this.check_for_collisions(card.x, card.y, card.rot, others, dont_overlap_allowance);
        }
        check_for_line_collisions(sx, sy, ex, ey, crot, others, dont_overlap_allowance = 2) {
            const collisions = [];
            for (let card of others) {
                const closest = this.closest_point_from_line_segment(card.x, card.y, sx, sy, ex, ey);
                if (this.do_cards_touch(closest[0], closest[1], crot, card, dont_overlap_allowance)) {
                    collisions.push(card);
                }
            }
            return collisions;
        }
        closest_point_from_line_segment(cx, cy, sx, sy, ex, ey) {
            // Adapted from https://stackoverflow.com/a/6853926
            const a = cx - sx;
            const b = cy - sy;
            const c = ex - sx;
            const d = ey - sy;
            const dot = a * c + b * d;
            const line_len_2 = c * c + d * d;
            // Zero length line.
            if (line_len_2 == 0)
                return [sx, sy];
            const dist_on_line = dot / line_len_2;
            if (dist_on_line < 0) {
                return [sx, sy];
            }
            else if (dist_on_line > 1) {
                return [ex, ey];
            }
            else {
                return [sx + dist_on_line * c, sy + dist_on_line * d];
            }
        }
        check_for_collisions(cx, cy, crot, others, dont_overlap_allowance = 2) {
            const collisions = [];
            for (let other of others) {
                if (this.do_cards_touch(cx, cy, crot, other, dont_overlap_allowance)) {
                    collisions.push(other);
                }
            }
            return collisions;
        }
        do_cards_touch(cx, cy, crot, other, dont_overlap_allowance) {
            if (other == null)
                return false;
            const cdist = this.compute_card_dist(crot);
            let overlap_allowance = other.tap_requirement == CTGCard_1.CTGTapRequirement.Dont ? dont_overlap_allowance : 0;
            const odist = this.compute_card_dist(other.rot);
            const xdist = cdist[0] + odist[0] - overlap_allowance;
            const ydist = cdist[1] + odist[1] - overlap_allowance;
            if (Math.abs(cx - other.x) < xdist
                && Math.abs(cy - other.y) < ydist) {
                return true;
            }
            return false;
        }
        compute_card_dist(crot) {
            return [
                (crot % 180 == 0 ? CTG_1.card_size[0] : CTG_1.card_size[1]) / 2,
                (crot % 180 == 0 ? CTG_1.card_size[1] : CTG_1.card_size[0]) / 2
            ];
        }
    }
    CTGGameMode.EVENT_CREATE = "c";
    CTGGameMode.EVENT_GAME_STARTED = "gs";
    CTGGameMode.EVENT_GAME_ENDED = "ge";
    CTGGameMode.EVENT_WON = "w";
    CTGGameMode.EVENT_LOST = "l";
    CTGGameMode.EVENT_SCORE_UPDATE = "su";
    CTGGameMode.EVENT_TIME_UPDATE = "tu";
    CTGGameMode.EVENT_INITIAL_CARDS = "ic";
    CTGGameMode.EVENT_ADD_CARDS = "ac";
    CTGGameMode.EVENT_SHOW_SHIELD = "ss";
    CTGGameMode.EVENT_HIDE_SHIELD = "hs";
    CTGGameMode.EVENT_CARD_DESTROYED = "cd";
    CTGGameMode.TIME_LIMIT = 12 * 1000;
    return CTGGameMode;
})();
exports.CTGGameMode = CTGGameMode;
